module.exports = "pegasus/assets/busy-bee.gif";